import React from 'react';

import cx from 'classnames';
import { useSelector } from 'react-redux';

import { isLoginAsSelector } from 'store/auth/selectors';
import { inIframe } from 'utils/browserDetect';

import styles from './index.module.css';
import LoginAsBar from './LoginAsBar';

const propTypes = {};
const defaultProps = {};

function Layout({ children }) {
  const isLoginAs = useSelector(isLoginAsSelector);
  const isInsideIframe = inIframe(); // check when react rendered inside SSR

  return (
    <div className={cx(styles.container, isLoginAs && 'override')}>
      {!isInsideIframe && isLoginAs && <LoginAsBar />}
      {children}
    </div>
  );
}

Layout.propTypes = propTypes;
Layout.defaultProps = defaultProps;

export default Layout;
